import React from 'react'

const RightArrow = ({onClick = null}) => {
    return (
        <svg onClick={onClick} width="43" height="43" viewBox="0 0 43 43" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle opacity="0.7" cx="21.1008" cy="21.1013" r="21.1008" transform="rotate(-180 21.1008 21.1013)" fill="white"/>
            <path d="M30.9971 21.4681C31.3877 21.0776 31.3877 20.4444 30.9971 20.0539L24.6332 13.6899C24.2427 13.2994 23.6095 13.2994 23.219 13.6899C22.8284 14.0804 22.8284 14.7136 23.219 15.1041L28.8758 20.761L23.219 26.4178C22.8284 26.8084 22.8284 27.4415 23.219 27.8321C23.6095 28.2226 24.2427 28.2226 24.6332 27.8321L30.9971 21.4681ZM12.2522 21.761L30.29 21.761L30.29 19.761L12.2522 19.761L12.2522 21.761Z" fill="#606060"/>
        </svg>

    )
}

export default RightArrow